import { CallCalling, Messages2, MessageText1, Ticket } from 'iconsax-react';

import { SupportBold } from '@shared/ui';

export const supportWidgetData = [
  {
    id: 'Phonecall',
    label: 'تماس تلفنی ۹۰۰۰۱۲۳۴',
    icon: CallCalling,
    onClickKey: 'openPhoneCall',
    iconProps: { size: 24 },
  },
  {
    id: 'Onlinechat',
    label: 'چت آنلاین',
    icon: Messages2,
    onClickKey: 'openOnlineChat',
    iconProps: { size: 24 },
  },
  {
    id: 'Ticket',
    label: 'ثبت تیکت ',
    icon: Ticket,
    onClickKey: 'openTicketDrawer',
    iconProps: { size: 24 },
  },
  {
    id: 'ّFeedBack',
    label: 'ثبت بازخورد ',
    icon: MessageText1,
    onClickKey: 'openFeedBackDrawer',
    iconProps: { size: 24 },
  },

  {
    id: 'Support_center',
    label: 'مرکز پشتیبانی',
    icon: SupportBold,
    onClickKey: 'goToSupportCenter',
    iconProps: { size: 24 },
  },
];
